import React from 'react';
import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';




import m382569 from '../media/ift/InternetAl/FormatoSimplificado_382569.pdf';
import m382570 from '../media/ift/InternetAl/FormatoSimplificado_382570.pdf';
import m382571 from '../media/ift/InternetAl/FormatoSimplificado_382571.pdf';
import m382572 from '../media/ift/InternetAl/FormatoSimplificado_382572.pdf';

import Formato_344762 from '../media/img_on_amazon/FormatoSimplificado_344762.pdf';
import Formato_344763 from '../media/img_on_amazon/FormatoSimplificado_344763.pdf';
import Formato_344764 from '../media/img_on_amazon/FormatoSimplificado_344764.pdf';

import m381784 from '../media/ift/InternetAlF/FormatoSimplificado_381784.pdf';
import m381786 from '../media/ift/InternetAlF/FormatoSimplificado_381786.pdf';
import m381789 from '../media/ift/InternetAlF/FormatoSimplificado_381789.pdf';
import m381792 from '../media/ift/InternetAlF/FormatoSimplificado_381792.pdf';


import m302936 from '../media/ift/InternetATF/FormatoSimplificado_302936.pdf';
import m302939 from '../media/ift/InternetATF/FormatoSimplificado_302939.pdf';
import m302946 from '../media/ift/InternetATF/FormatoSimplificado_302946.pdf';
import m314635 from '../media/ift/InternetATF/FormatoSimplificado_314635.pdf';
import m302948 from '../media/ift/InternetATF/FormatoSimplificado_302948.pdf';
import m302958 from '../media/ift/InternetATF/FormatoSimplificado_302958.pdf';
import m302960 from '../media/ift/InternetATF/FormatoSimplificado_302960.pdf';
import m314639 from '../media/ift/InternetATF/FormatoSimplificado_314639.pdf';


import m305582 from '../media/ift/InternetAlTFF/FormatoSimplificado_305582.pdf';
import m305587 from '../media/ift/InternetAlTFF/FormatoSimplificado_305587.pdf';
import m305588 from '../media/ift/InternetAlTFF/FormatoSimplificado_305588.pdf';
import m316295 from '../media/ift/InternetAlTFF/FormatoSimplificado_316295.pdf';
import m305589 from '../media/ift/InternetAlTFF/FormatoSimplificado_305589.pdf';
import m305592 from '../media/ift/InternetAlTFF/FormatoSimplificado_305592.pdf';
import m305594 from '../media/ift/InternetAlTFF/FormatoSimplificado_305594.pdf';
import m316307 from '../media/ift/InternetAlTFF/FormatoSimplificado_316307.pdf';


import m306099 from '../media/ift/InternetSat/FormatoSimplificado_306099.pdf';
import m306103 from '../media/ift/InternetSat/FormatoSimplificado_306103.pdf';
import m306350 from '../media/ift/InternetSat/FormatoSimplificado_306350.pdf';
import m306355 from '../media/ift/InternetSat/FormatoSimplificado_306355.pdf';
import m306359 from '../media/ift/InternetSat/FormatoSimplificado_306359.pdf';
import m306144 from '../media/ift/InternetSat/FormatoSimplificado_306144.pdf';
import m306361 from '../media/ift/InternetSat/FormatoSimplificado_306361.pdf';
import m306153 from '../media/ift/InternetSat/FormatoSimplificado_306153.pdf';


import m306225 from '../media/ift/InternetSatF/FormatoSimplificado_306225.pdf';
import m306227 from '../media/ift/InternetSatF/FormatoSimplificado_306227.pdf';
import m306230 from '../media/ift/InternetSatF/FormatoSimplificado_306230.pdf';
import m306233 from '../media/ift/InternetSatF/FormatoSimplificado_306233.pdf';
import m306234 from '../media/ift/InternetSatF/FormatoSimplificado_306234.pdf';
import m306235 from '../media/ift/InternetSatF/FormatoSimplificado_306235.pdf';
import m306237 from '../media/ift/InternetSatF/FormatoSimplificado_306237.pdf';
import m306238 from '../media/ift/InternetSatF/FormatoSimplificado_306238.pdf';


import m307285 from '../media/ift/InternetInRecargas/FormatoSimplificado_307285.pdf';
import m307286 from '../media/ift/InternetInRecargas/FormatoSimplificado_307286.pdf';
import m307287 from '../media/ift/InternetInRecargas/FormatoSimplificado_307287.pdf';














import m1001350 from '../media/ift/InternetSatF/FormatoSimplificado_1001350.pdf';
import m1001333 from '../media/ift/InternetSatF/FormatoSimplificado_1001333.pdf';
import m1001346 from '../media/ift/InternetSatF/FormatoSimplificado_1001346.pdf';
import m1001347 from '../media/ift/InternetSatF/FormatoSimplificado_1001347.pdf';
import m1001338 from '../media/ift/InternetSatF/FormatoSimplificado_1001338.pdf';
import m1001344 from '../media/ift/InternetSatF/FormatoSimplificado_1001344.pdf';
import m1001356 from '../media/ift/InternetSatF/FormatoSimplificado_1001356.pdf';
import m1001361 from '../media/ift/InternetSatF/FormatoSimplificado_1001361.pdf';
import m1001365 from '../media/ift/InternetSatF/FormatoSimplificado_1001365.pdf';
import m1001366 from '../media/ift/InternetSatF/FormatoSimplificado_1001366.pdf';
import m1001367 from '../media/ift/InternetSatF/FormatoSimplificado_1001367.pdf';
import m1001359 from '../media/ift/InternetSatF/FormatoSimplificado_1001359.pdf';





const Rates = props =>
{
    return (
        <div id='rates' className='container p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h4 className='mb-4'>REGISTRO DE TARIFAS ANTE IFT</h4>


                  <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO PLANES POSTPAGO</th>
                        </tr>
                        <tr className='thead-dark'>
                             <th className='td-title' colspan="2">Disponibles para venta nueva</th>
                        </tr>

                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>ON Inalámbrico Internet 5 con renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/157056126230215mb80gb.pdf' target='_blank' rel='noopener noreferrer'>247333</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico Internet 10 con renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/1570562211917710mb120gb.pdf' target='_blank' rel='noopener noreferrer'>247337</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico Internet 20 con renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/1570562480100220mb180gb.pdf' target='_blank' rel='noopener noreferrer'>247339</a></td>
                        </tr>
               
                        <tr>
                            <td className='td-title' colSpan='2'>Paquetes GB adicionales que aplican para todos los paquetes</td>
                        </tr>
                        <tr>
                            <td>Paquete adicional 5 GB Inalámbrico</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/157323024420385gb.pdf' target='_blank' rel='noopener noreferrer'>254776</a></td>
                        </tr>
                        
                    </tbody>
                </table>


                <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO</th>
                        </tr>
                        <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INTERNET + AMAZON PRIME</th>
                        </tr>

                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>Paquete ON Inalámbrico Internet 5 con servicio prestado por terceros</td>
                            <td><a href={Formato_344762} target='_blank'>344762</a></td>
                        </tr>
                        <tr>
                            <td>Paquete ON Inalámbrico Internet 10 con servicio prestado por terceros</td>
                            <td><a href={Formato_344763} target='_blank'>344763</a></td>
                        </tr>
                        <tr>
                            <td>Paquete ON Inalámbrico Internet 10 con servicio prestado por terceros</td>
                            <td><a href={Formato_344764} target='_blank'>344764</a></td>
                        </tr>
                        
                    </tbody>
                </table>



                



                   <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO PLANES POSTPAGO FRANJA FRONTERIZA</th>
                        </tr>


                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>ON Inalámbrico Internet 5 con renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/15868021702477oninalambrico5mb80gbeq.pdf' target='_blank' rel='noopener noreferrer'>298543</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico Internet 10 con renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/1586802567906oninalambrico10mb120gbeq.pdf' target='_blank' rel='noopener noreferrer'>298546</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico Internet 20 con renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/15868030465965oninalambrico20mb180gbeq.pdf' target='_blank' rel='noopener noreferrer'>298549</a></td>
                        </tr>
                       
                        <tr>
                            <td className='td-title' colSpan='2'>Paquetes GB adicionales que aplican para todos los paquetes</td>
                        </tr>
                        <tr>
                            <td>Paquete adicional 5 GB Inalámbrico</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/15868235699810paqueteadicional.pdf' target='_blank' rel='noopener noreferrer'>298600</a></td>
                        </tr>
                        
                       
                      
                    </tbody>
                </table>






                   <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">NO disponibles para venta nueva </th>
                        </tr>
                          <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO PLANES POSTPAGO  </th>
                        </tr>
                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>ON Inalámbrico Internet 5 sin renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/157056197664395mb80gb2.pdf' target='_blank' rel='noopener noreferrer'>247335</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico Internet 10 sin renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/1570562366721610mb120gb2.pdf' target='_blank' rel='noopener noreferrer'>247338</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico Internet 20 sin renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/1570562578145220mb180gb2.pdf' target='_blank' rel='noopener noreferrer'>247340</a></td>
                        </tr>
                       
                    </tbody>
                </table>


                     <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">NO disponibles para venta nueva </th>
                        </tr>
                          <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO PLANES POSTPAGO FRANJA FRONTERIZA </th>
                        </tr>
                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>ON Inalámbrico Internet 5 sin renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/15868023629082oninalambrico5mb80gb.pdf' target='_blank' rel='noopener noreferrer'>298545</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico Internet 10 sin renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/15868027963859oninalambrico10mb120gb.pdf' target='_blank' rel='noopener noreferrer'>298547</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico Internet 20 sin renta de equipo</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/15868031735538oninalambrico20mb180gb.pdf' target='_blank' rel='noopener noreferrer'>298551</a></td>
                        </tr>
                       
                    </tbody>
                </table>



                 <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON Inalámbrico Recargas Prepago</th>
                        </tr>
                        <tr>
                            <th>ON INALÁMBRICO</th>
                            <th>FOLIO DE TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>ON Inalámbrico 5  / 20 GB / semanal</td>
                            <td><a href={m307285} target='_blank' rel='noopener noreferrer'>307285</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico 5  / 80 GB / mensual</td>
                            <td><a href={m307286} target='_blank' rel='noopener noreferrer'>307286</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico 10  / 120 GB / mensual</td>
                            <td><a href={m307287} target='_blank' rel='noopener noreferrer'>307287</a></td>
                        </tr>
                       
                        
                       
                      
                    </tbody>
                </table>



                  <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>
                        
                    </thead>
                    <tbody>
                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON ALÁMBRICO: INTERNET</th>
                        </tr> 
                        <tr className='thead-dark'>
                             <th className='td-title'>NOMBRE</th>
                            <th className='td-title'>TARIFA</th>
                        </tr>
                          <tr>
                            <td>ON Alámbrico Internet 20</td>
                            <td><a href={m382569} target='_blank' rel='noopener noreferrer'>382569</a></td>
                        </tr>
                        <tr>
                            <td>ON Alámbrico Internet 30</td>
                            <td><a href={m382570} target='_blank' rel='noopener noreferrer'>382570</a></td>
                        </tr>
                        <tr>
                            <td>ON Alámbrico Internet 150 </td>
                            <td><a href={m382571} target='_blank' rel='noopener noreferrer'>382571</a></td>
                        </tr>
                        <tr>
                            <td>ON Alámbrico Internet 200</td>
                            <td><a href={m382572} target='_blank' rel='noopener noreferrer'>382572</a></td>
                        </tr>


                    </tbody>
                </table>

                <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>
                        
                    </thead>
                    <tbody>
                        
                        <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON ALÁMBRICO: INTERNET IVA FRONTERIZO</th>
                        </tr>
                        <tr className='thead-dark'>
                           <th className='td-title'>NOMBRE</th>
                            <th className='td-title'>TARIFA</th>
                        </tr>
                          <tr>
                            <td>ON Alámbrico Internet 20</td>
                            <td><a href={m381784} target='_blank' rel='noopener noreferrer'>381784</a></td>
                        </tr>
                        <tr>
                            <td>ON Alámbrico Internet 30</td>
                            <td><a href={m381786} target='_blank' rel='noopener noreferrer'>381786</a></td>
                        </tr>
                        <tr>
                            <td>ON Alámbrico Internet 150 </td>
                            <td><a href={m381789} target='_blank' rel='noopener noreferrer'>381789</a></td>
                        </tr>
                        <tr>
                            <td>ON Alámbrico Internet 200</td>
                            <td><a href={m381792} target='_blank' rel='noopener noreferrer'>381792</a></td>
                        </tr>


                    </tbody>
                </table>


                   <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON ALÁMBRICO INTERNET + TELEFONÍA FIJA</th>
                        </tr>
                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>Paquete 1 ON Internet Alámbrico + TF 389</td>
                            <td><a href={m302936} target='_blank' rel='noopener noreferrer'>302936</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 2 ON Internet Alámbrico + TF 435</td>
                            <td><a href={m302939} target='_blank' rel='noopener noreferrer'>302939</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 3 ON Internet Alámbrico + TF 499</td>
                            <td><a href={m302946} target='_blank' rel='noopener noreferrer'>302946</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 5 ON Internet Alámbrico + TF 599</td>
                            <td><a href={m314635} target='_blank' rel='noopener noreferrer'>314635</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 4 ON Internet Alámbrico + TF 999</td>
                            <td><a href={m302948} target='_blank' rel='noopener noreferrer'>302948</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 435</td>
                            <td><a href={m302958} target='_blank' rel='noopener noreferrer'>302958</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 499</td>
                            <td><a href={m302960} target='_blank' rel='noopener noreferrer'>302960</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 599</td>
                            <td><a href={m314639} target='_blank' rel='noopener noreferrer'>314639</a></td>
                        </tr>
                       
                       
                    </tbody>
                </table>


              

                  <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON ALÁMBRICO INTERNET + TELEFONÍA FIJA IVA FRONTERIZO</th>
                        </tr>
                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>Paquete 1 ON Internet Alámbrico + TF 389</td>
                            <td><a href={m305582} target='_blank' rel='noopener noreferrer'>305582</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 2 ON Internet Alámbrico + TF 435</td>
                            <td><a href={m305587} target='_blank' rel='noopener noreferrer'>305587</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 3 ON Internet Alámbrico + TF 499</td>
                            <td><a href={m305588} target='_blank' rel='noopener noreferrer'>305588</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 5 ON Internet Alámbrico + TF 599</td>
                            <td><a href={m316295} target='_blank' rel='noopener noreferrer'>316295</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 4 ON Internet Alámbrico + TF 999</td>
                            <td><a href={m305589} target='_blank' rel='noopener noreferrer'>305589</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 435</td>
                            <td><a href={m305592} target='_blank' rel='noopener noreferrer'>305592</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 499</td>
                            <td><a href={m305594} target='_blank' rel='noopener noreferrer'>305594</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 599</td>
                            <td><a href={m316307} target='_blank' rel='noopener noreferrer'>316307</a></td>
                        </tr>

                       
                    </tbody>
                </table>


              
                 <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>
                      
                    </thead>
                    <tbody>
                        <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON SATELITAL</th>
                        </tr>
                        <tr className='thead-dark'>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                      
                        <tr><td>ON Satelital Internet 3 con 5 GB </td>
                            <td><a href={m1001350} target='_blank' rel='noopener noreferrer'>1001350</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 5 con 15 GB</td>
                            <td><a href={m306103} target='_blank' rel='noopener noreferrer'>306103</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 10 con 20 GB   </td>
                            <td><a href={m306350} target='_blank' rel='noopener noreferrer'>306350</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 10 con 40 GB   </td>
                            <td><a href={m306355} target='_blank' rel='noopener noreferrer'>306355</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 20 con 60 GB   </td>
                            <td><a href={m306359} target='_blank' rel='noopener noreferrer'>306359</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 30 con 100 GB  </td>
                            <td><a href={m1001338} target='_blank' rel='noopener noreferrer'>1001338</a></td>
                        </tr>
                         <tr><td>ON Satelital Internet 30 con 150 GB </td>
                            <td><a href={m1001344} target='_blank' rel='noopener noreferrer'>1001344</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 25 con 20 GB   </td>
                            <td><a href={m1001333} target='_blank' rel='noopener noreferrer'>1001333</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 25 con 40 GB   </td>
                            <td><a href={m1001346} target='_blank' rel='noopener noreferrer'>1001346</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 25 con 60 GB   </td>
                            <td><a href={m1001347} target='_blank' rel='noopener noreferrer'>1001347</a></td>
                        </tr>

                        <th className='td-title' colspan="2">Paquetes GB adicionales que aplican para todos los paquetes</th>

                        <tr><td>Paquete adicional 1 GB </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359574</a></td>
                        </tr>
                        <tr><td>Paquete adicional 3 GB</td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359578</a></td>
                        </tr>
                        <tr><td>Paquete adicional 5 GB   </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359582</a></td>
                        </tr>
                        <tr><td>Paquete adicional 10 GB   </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359583</a></td>
                        </tr>


                    </tbody>
                </table>





                 <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>
                      
                    </thead>
                    <tbody>
                       
                        <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON SATELITAL IVA FRONTERIZO</th>
                        </tr>
                        <tr className='thead-dark'>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                        <tr><td>ON Satelital Internet 3 con 5 GB </td>
                            <td><a href={m1001356} target='_blank' rel='noopener noreferrer'>1001356</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 5 con 15 GB</td>
                            <td><a href={m306227} target='_blank' rel='noopener noreferrer'>306227</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 10 con 20 GB   </td>
                            <td><a href={m306230} target='_blank' rel='noopener noreferrer'>306230</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 10 con 40 GB   </td>
                            <td><a href={m306233} target='_blank' rel='noopener noreferrer'>306233</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 20 con 60 GB   </td>
                            <td><a href={m306234} target='_blank' rel='noopener noreferrer'>306234</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 30 con 100 GB  </td>
                            <td><a href={m1001367} target='_blank' rel='noopener noreferrer'>1001367</a></td>
                        </tr>
                         <tr><td>ON Satelital Internet 30 con 150 GB </td>
                            <td><a href={m1001359} target='_blank' rel='noopener noreferrer'>1001359</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 25 con 20 GB   </td>
                            <td><a href={m1001361} target='_blank' rel='noopener noreferrer'>1001361</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 25 con 40 GB   </td>
                            <td><a href={m1001365} target='_blank' rel='noopener noreferrer'>1001365</a></td>
                        </tr>
                        <tr><td>ON Satelital Internet 25 con 60 GB   </td>
                            <td><a href={m1001366} target='_blank' rel='noopener noreferrer'>1001366</a></td>
                        </tr>


                        
                        <th className='td-title' colspan="2">Paquetes GB adicionales que aplican para todos los paquetes</th>

                        <tr><td>Paquete adicional 1 GB </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359587</a></td>
                        </tr>
                        <tr><td>Paquete adicional 3 GB</td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359590</a></td>
                        </tr>
                        <tr><td>Paquete adicional 5 GB   </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359596</a></td>
                        </tr>
                        <tr><td>Paquete adicional 10 GB   </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359603</a></td>
                        </tr>

                    </tbody>
                </table>


                <p>Las tarifas ante señaladas pueden consultarse en el Registro Público de Concesiones, publicado en la página electrónica del Instituto Federal de Telecomunicaciones.</p>
            </TocPage>
        </div>
    );
}

export default Rates;


// WEBPACK FOOTER //
// ./src/components/Rates.js